import { useMyLoot } from '@/hooks/queries'
import { MyLoot } from '@/components/MyLoot'
import { AccountPage } from './account/AccountPage'
import { SkeletonLine } from '@/components/ui/Skeleton'

/** `/my/loot` — every key this account has won. */
export function MyLootPage() {
  const { data: prizes = [], isPending } = useMyLoot()

  return (
    <AccountPage
      title="My Loot"
      meta={
        isPending ? (
          <SkeletonLine width="5em" />
        ) : (
          `${prizes.length} ${prizes.length === 1 ? 'key' : 'keys'}`
        )
      }
    >
      <MyLoot />
    </AccountPage>
  )
}
